import { ContentLoader } from "@trussle/external-components";
import React, { FC } from "react";
import "./styles.scss";

interface ILoaderFormQuestion {
  numberOfQuestions: number;
}

export const LoaderFormQuestion: FC<ILoaderFormQuestion> = ({
  numberOfQuestions,
}) => (
  <>
    {[...Array(numberOfQuestions)].map((_item, index) => (
      <div className="loading-form-row" key={`loading-form-row-${index}`} data-testid="loading-form-row">
        <ContentLoader className="loading-label" />
        <ContentLoader className="loading-field" />
      </div>
    ))}
  </>
);
